import { LOGO_URL } from '@/pages/landing/components/data';

export { LOGO_URL };

export interface PlataformaNavLink {
  label: string;
  href: string;
}

export const PLATAFORMA_NAV_LINKS: PlataformaNavLink[] = [
  { label: 'Visão geral', href: '#modulos' },
  { label: 'Estratégia', href: '#estrategia' },
  { label: 'Engajamento', href: '#engajamento' },
  { label: 'Premiação', href: '#premiacao' },
  { label: 'Confiança', href: '#confianca' },
];

export const PLATAFORMA_HERO_BG =
  'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20orange%20gradient%20hero%20background%20representing%20a%20unified%20incentive%20platform%20ecosystem%20with%20soft%20glowing%20network%20nodes%20and%20connection%20lines%20flowing%20organically%20toward%20a%20bright%20horizon%2C%20premium%20technology%20aesthetic%2C%20clean%20minimal%20composition%2C%20warm%20golden%20orange%20tones%20with%20cream%20highlights%2C%20subtle%20depth%20of%20field%2C%20no%20text%2C%20high%20detail&width=1920&height=1080&seq=gp-plataforma-hero-01&orientation=landscape';

export const PLATAFORMA_HERO_WOMAN =
  'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/4c7938bffdd6b279aee6d926fcda0f2f.png';

export const PLATAFORMA_DIFERENCIAL_IMG =
  'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/34ae44b42eb0c5908f68e9789bd55296.png';

export interface Modulo {
  icon: string;
  title: string;
  description: string;
}

export interface GrupoModulo {
  id: string;
  badge: string;
  icon: string;
  title: string;
  lead: string;
  description: string;
  tone: 'primary' | 'accent' | 'secondary';
  modulos: Modulo[];
}

export const GRUPOS_MODULOS: GrupoModulo[] = [
  {
    id: 'estrategia',
    badge: '01 · Estratégia & Resultados',
    icon: 'ri-line-chart-line',
    title: 'Estratégia & Resultados',
    lead: 'Decida com dados e saia com ROI',
    description:
      'Do planejamento à apuração: simule o retorno, monte a campanha e acompanhe o resultado em tempo real, sem depender de TI.',
    tone: 'primary',
    modulos: [
      {
        icon: 'ri-flag-2-line',
        title: 'Campanhas de Incentivo',
        description:
          'Metas, rankings e desafios criados para direcionar comportamento e acelerar vendas, configurados em poucos cliques.',
      },
      {
        icon: 'ri-brain-line',
        title: 'Simulador de ROI com IA',
        description:
          'Descubra o retorno estimado da sua campanha antes de lançar. Configure cenários e saia com números que sustentam a decisão.',
      },
      {
        icon: 'ri-bar-chart-2-line',
        title: 'Apuração de Resultados',
        description:
          'Automatize a coleta e o processamento dos dados. O número entra, o resultado sai na ponta — para o gestor e para o participante.',
      },
      {
        icon: 'ri-dashboard-line',
        title: 'Analytics em Tempo Real',
        description:
          'Dashboards em tempo real para acompanhar metas, engajamento e performance por região, produto ou equipe.',
      },
    ],
  },
  {
    id: 'engajamento',
    badge: '02 · Engajamento & Gamificação',
    icon: 'ri-trophy-line',
    title: 'Engajamento & Gamificação',
    lead: 'Transforme rotina em competição saudável',
    description:
      'XP, níveis, missões, jogos e treinamento gamificado: tudo para manter o time motivado do primeiro ao último dia da campanha.',
    tone: 'accent',
    modulos: [
      {
        icon: 'ri-trophy-line',
        title: 'Gamificação e Ranking',
        description:
          'XP, níveis, distintivos e rankings que mantêm o time motivado e com foco na meta até o último dia.',
      },
      {
        icon: 'ri-gamepad-line',
        title: 'Games e Missões',
        description:
          'Desafios diários e jogos que transformam a rotina de vendas em uma experiência competitiva e divertida.',
      },
      {
        icon: 'ri-smartphone-line',
        title: 'App do Participante',
        description:
          'A experiência mobile completa: campanhas, missões, extrato, feed e suporte na palma da mão, sem download.',
      },
      {
        icon: 'ri-graduation-cap-line',
        title: 'Treinamento e Capacitação',
        description:
          'Educação de canal gamificada para capacitar vendedores e parceiros enquanto eles engajam e pontuam.',
      },
    ],
  },
  {
    id: 'premiacao',
    badge: '03 · Premiação & Resgate',
    icon: 'ri-gift-line',
    title: 'Premiação & Resgate',
    lead: 'Reconheça resultados de verdade',
    description:
      'Do PIX ao cartão digital, do marketplace às experiências: premiação rápida, com a menor taxa do mercado e toda a documentação em dia.',
    tone: 'secondary',
    modulos: [
      {
        icon: 'ri-gift-2-line',
        title: 'Premiação',
        description:
          'Reconheça resultados com prêmios que geram desejo: dinheiro, produtos, viagens e experiências inesquecíveis.',
      },
      {
        icon: 'ri-bank-card-line',
        title: 'Carteira Digital e Resgates',
        description:
          'PIX, pagamento de contas e cartão digital pré-pago na mão do participante, com a menor taxa do mercado.',
      },
      {
        icon: 'ri-shopping-bag-3-line',
        title: 'Marketplace de Prêmios',
        description:
          'Vouchers, produtos e experiências exclusivas em um catálogo curado para cada perfil de participante.',
      },
      {
        icon: 'ri-file-list-3-line',
        title: 'Comprovantes e Nota Fiscal',
        description:
          'Extrato transparente e documentação fiscal gerada automaticamente a cada resgate, para todo mundo ficar em dia.',
      },
    ],
  },
  {
    id: 'confianca',
    badge: '04 · Plataforma & Confiança',
    icon: 'ri-shield-check-line',
    title: 'Plataforma & Confiança',
    lead: 'Escale com segurança e sem fricção',
    description:
      'Gestão de participantes, multiempresa, integrações e conformidade regulatória: a base sólida para crescer sem dor de cabeça.',
    tone: 'primary',
    modulos: [
      {
        icon: 'ri-team-line',
        title: 'Gestão de Participantes',
        description:
          'Convites, onboarding e cadastro em massa com controle total de quem participa e como participa.',
      },
      {
        icon: 'ri-building-2-line',
        title: 'Multiempresa e Grupos',
        description:
          'Holdings e franquias gerenciando múltiplas empresas e programas em um só lugar, com visões segregadas.',
      },
      {
        icon: 'ri-plug-line',
        title: 'Integrações e API',
        description:
          'ERP, CRM, PDV e sistemas legados conectados via API, webhooks e documentação completa para implantação ágil.',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Segurança, LGPD e Conformidade',
        description:
          'Aderente a regulações financeiras e fiscais, com segregação de contas, auditoria e trilha de rastreabilidade.',
      },
    ],
  },
];

export interface GrupoDestaqueMeta {
  eyebrow: string;
  eyebrowIcon: string;
  titleTop: string;
  titleBottomPrefix: string;
  titleHighlight: string;
  annotationTop: string;
  annotationBottom: string;
  floating: string;
  floatingIcon: string;
}

export const GRUPO_DESTAQUE_META: Record<string, GrupoDestaqueMeta> = {
  estrategia: {
    eyebrow: 'Resultados na prática',
    eyebrowIcon: 'ri-bar-chart-box-line',
    titleTop: 'Decida com dados',
    titleBottomPrefix: 'e saia com',
    titleHighlight: 'ROI',
    annotationTop: '',
    annotationBottom: '',
    floating: '',
    floatingIcon: 'ri-arrow-right-up-line',
  },
  engajamento: {
    eyebrow: 'Engajamento que vicia',
    eyebrowIcon: 'ri-gamepad-line',
    titleTop: 'Gamifique a rotina',
    titleBottomPrefix: 'e eleve a',
    titleHighlight: 'performance',
    annotationTop: '',
    annotationBottom: '',
    floating: '',
    floatingIcon: 'ri-trophy-line',
  },
  premiacao: {
    eyebrow: 'Premiação na ponta',
    eyebrowIcon: 'ri-gift-2-line',
    titleTop: 'Do resultado ao resgate',
    titleBottomPrefix: 'em poucos toques',
    titleHighlight: '',
    annotationTop: 'Prêmio na hora certa',
    annotationBottom: 'Reconhecer é reter.',
    floating: 'Resgate rápido e sem papelada',
    floatingIcon: 'ri-flashlight-line',
  },
  confianca: {
    eyebrow: 'Confiança em primeiro lugar',
    eyebrowIcon: 'ri-shield-check-line',
    titleTop: 'Segurança para crescer',
    titleBottomPrefix: 'com total',
    titleHighlight: 'conformidade',
    annotationTop: 'Tudo auditável',
    annotationBottom: 'Conformidade que dá tranquilidade.',
    floating: 'Pronto para crescer sem risco',
    floatingIcon: 'ri-shield-check-line',
  },
};

export const DIFERENCIAIS = [
  {
    icon: 'ri-percent-line',
    title: 'Menor taxa do mercado',
    description: 'Premiação via PIX e cartão digital com as taxas mais competitivas do setor.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Conformidade Bacen',
    description: 'Operação alinhada aos atuais regulamentações com auditoria e trilha completa.',
  },
  {
    icon: 'ri-links-line',
    title: 'Tudo integrado',
    description: 'Estratégia, engajamento, premiação e dados conectados em um único ecossistema.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Time dedicado',
    description: 'Especialistas cuidando da comunicação e do engajamento do programa por você.',
  },
];

export interface SocialLink {
  label: string;
  href: string;
  icon: string;
}

export const SOCIAL_LINKS: SocialLink[] = [
  { label: 'LinkedIn da GetPoints', href: 'https://www.linkedin.com', icon: 'ri-linkedin-fill' },
  { label: 'Instagram da GetPoints', href: 'https://www.instagram.com', icon: 'ri-instagram-line' },
  { label: 'YouTube da GetPoints', href: 'https://www.youtube.com', icon: 'ri-youtube-fill' },
];

export interface HeroPilar {
  label: string;
  icon: string;
}

export const PLATAFORMA_HERO_PILARES: HeroPilar[] = [
  { label: 'Campanhas de Incentivo', icon: 'ri-focus-3-line' },
  { label: 'Gamificação e Ranking', icon: 'ri-gamepad-line' },
  { label: 'App do Participante', icon: 'ri-smartphone-line' },
  { label: 'Carteira Digital', icon: 'ri-wallet-3-line' },
  { label: 'Simulador de ROI', icon: 'ri-bar-chart-2-line' },
  { label: 'Integrações e API', icon: 'ri-links-line' },
  { label: 'Segurança e LGPD', icon: 'ri-shield-check-line' },
  { label: 'Apuração de Resultados', icon: 'ri-pie-chart-2-line' },
];